/* eslint-disable no-unused-vars */
import { List, Record as record } from 'immutable';
import PropTypes from 'prop-types';

import trainTime from '../../lib/TrainTime';
import { fields, resolveAll } from '../../helpers/LinkMapper';
import { serialize, serializers, deserialize, deserializers } from '../../helpers/SearchUrls';

import PassengerRailcard from '../../records/PassengerRailcard';
import ValidationMixin from '../ValidationMixin';
import validators from '../../validation';
import Station from '../Station';

const defaults = {
    adults: 1,
    children: 0,
    destination: new Station(),
    origin: new Station(),
    railcards: new List()
};

export class OpenSearchRecord extends record(defaults) {
    serialize () {
        return serialize({
            origin: serializers.station,
            adults: serializers.identity,
            children: serializers.identity,
            railcards: serializers.railcards,
        }, this);
    }

    /**
     * Return a promise that resolves to a new Search, from the url params
     */
    static deserialize (params, query) {
        const source = Object.assign({}, query, params);
        const schema = {
            origin: deserializers.station,
            adults: deserializers.int,
            children: deserializers.int,
            railcards: deserializers.railcards,
        };

        return deserialize(schema, source).then((deserialized) => {
            return new OpenSearchRecord(deserialized);
        });
    }

    getComputedValues () {
        return {
            adults: fields.number,
            children: fields.number,
            destination: this.destination.getName(),
            origin: this.origin.getName(),
            railcards: resolveAll.as(PassengerRailcard)
        };
    }

    getSchema () {
        return {
            // date: validators.required(),
            time: validators.required(),
            origin: validators.requiredString(),
            submitted: validators.optional(),
        };
    }

    isValid () {
        return !this.origin.isEmpty();
    }
}

export const OpenSearchRecordShape = PropTypes.shape({
    destination: PropTypes.instanceOf(Station).isRequired,
    origin: PropTypes.instanceOf(Station).isRequired,
});

Object.assign(OpenSearchRecord.prototype, ValidationMixin);

export default OpenSearchRecord;



// WEBPACK FOOTER //
// ./src/records/widgets/OpenSearchRecord.js